// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "resources/js/chunks/" + ({"103":"odep-icon-3","487":"odep-icon-0","784":"odep-icon-1","839":"odep-icon-2"}[chunkId] || chunkId) + ".legacy." + {"103":"181fb7ab03d004406d77","487":"d7999d901e9c867f5da0","700":"ce362f8e1e2b05ff8645","784":"ad6013d506ec97728077","839":"8c0c8a82f20e45891a2c"}[chunkId] + ".js";
};